export const state = () => ({
    revision: null,
    intendedUrl: null,
})

export const mutations = {
    updateRevision(state, payload = {}) {
        state.revision = payload
    },
    updateIntendedUrl(state, payload = {}) {
        state.intendedUrl = payload
    },
}
